import { useState } from "react";
import { Ban } from "lucide-react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

export const VoidButton = ({ onConfirm }) => {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  return (
    <>
      <button data-testid="movement-void-btn" onClick={() => setOpen(true)} className="mt-1 inline-flex items-center gap-1 text-xs text-red-600 dark:text-red-400 hover:underline">
        <Ban className="w-3 h-3" /> Anular
      </button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent data-testid="void-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Anular movimiento</AlertDialogTitle>
            <AlertDialogDescription>El movimiento queda en el historial marcado como anulado y deja de contar en los totales. No se puede deshacer.</AlertDialogDescription>
          </AlertDialogHeader>
          <textarea data-testid="void-reason-input" className="c-input" rows={2} placeholder="Motivo (opcional)" value={reason} onChange={(e) => setReason(e.target.value)} />
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="void-cancel-btn">Cancelar</AlertDialogCancel>
            <AlertDialogAction data-testid="void-confirm-btn" className="bg-red-600 hover:bg-red-700 text-white" onClick={() => onConfirm(reason.trim() || null)}>Anular</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
